import { Alert } from "@mui/material";
import NavBar from "@components/NavBar";
import { Link } from "react-router-dom";

export default function NoAccessScreen() {
  return (
    <main className="flex flex-col container mx-auto p-5">
      <NavBar />
      <section className="flex flex-col gap-4 mt-4">
        <div className="flex justify-center items-center min-h-[60vh]">
          <Alert
            severity="warning"
            className="max-w-2xl"
          >
            <div className="flex flex-col gap-2">
              <h2 className="text-xl font-bold">Access Restricted</h2>
              <p>
                You do not have permission to view OTT applications. Please contact your administrator to request
                access.
              </p>
              <p className="text-sm mt-2">
                If you believe this is an error, please reach out to{" "}
                <Link
                  to="mailto:support@invintus.com?subject=OTT%20Access%20Request"
                  className="hover:underline font-semibold"
                >
                  support@invintus.com
                </Link>
              </p>
            </div>
          </Alert>
        </div>
      </section>
    </main>
  );
}
